import React, {FC} from 'react';

import {Trans} from '../../../../libs/shared/core/src/helpers/internationalization/react';
import {Banner, BannerTypesEnum} from '../../../../libs/shared/ui/src/components/banners/banner';
import {BannerCloseAction} from '../../../../libs/shared/ui/src/components/banners/bannerCloseAction';
import {BannerIcon} from '../../../../libs/shared/ui/src/components/banners/bannerIcon';
import {BannerPrioritiesEnum} from '../../../../libs/shared/ui/src/components/banners/bannersContext';
import {BannerText} from '../../../../libs/shared/ui/src/components/banners/bannerText';
import {
  LensesSuccessBannerState,
  LensesSuccessBannerTypesEnum,
} from '../../../store/panels/app/banners/bannersState';

interface LensesSuccessBannerProps {
  banner: LensesSuccessBannerState;
  onClose: () => void;
}

export const LensesSuccessBanner: FC<LensesSuccessBannerProps> = (props) => {
  const {banner, onClose} = props;

  return (
    <Banner bannerType={BannerTypesEnum.INLINE} priority={BannerPrioritiesEnum.INFORMATION}>
      <BannerIcon iconName="checkmarkCircleSmall" />
      <BannerText>{renderLensSuccessBannerContent(banner.lensesSuccessType, banner.lensName)}</BannerText>
      <BannerCloseAction onClick={onClose} />
    </Banner>
  );
};

export function renderLensSuccessBannerContent(bannerType: LensesSuccessBannerTypesEnum, lensName: string) {
  switch (bannerType) {
    case LensesSuccessBannerTypesEnum.LENS_CREATED:
      return <Trans id="banner-lens-create-success">View &quot;{lensName}&quot; has been created</Trans>;
    case LensesSuccessBannerTypesEnum.LENS_EDITED:
      return <Trans id="banner-lens-edit-success">View &quot;{lensName}&quot; has been updated</Trans>;
    default:
      return null;
  }
}
